<template>
    <div id="coins-banner">
        <!--=====================================-->
        <!--=        Banner Area Start         =-->
        <!--=====================================-->
        <section class="section">
            <div class="container">
                <div 
                    class="project-add-banner bg-gradient-green mb-0" 
                    data-sal="slide-up" 
                    data-sal-duration="1000"
                    :style="`background-image: url(${imgBase}${banner}); background-repeat: no-repeat; background-size: cover;`">
                    <div class="content">
                        <div class="row align-items-center form-floating-parent">
                            <div class="col-lg-7 col-xl-7 col-xxl-7">
                                <!-- <span class="subtitle">Alcanza tus metas financieras en automático.</span> -->
                                <h1 class="bold text-wrap-balance">
                                    <slot name="title"></slot>
                                </h1>
                                <!-- <button type="submit" class="axil-btn btn-borderd btn-fluid btn-primary rg-style-button-black w-auto"
                                    name="submit-btn">Conoce más</button> -->
                            </div>
                            <!-- BANNER FORM -->
                            <div class="col-lg-5 col-xl-5 col-xxl-5 form-floating-child">
                                <applicantOnboardingCard 
                                    :nameHolder="getPlaceHolders.nameHolder" 
                                    :emailHolder="getPlaceHolders.emailHolder" 
                                    urlPath="registerApplicant"
                                    :originLanding="getOriginLanding"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import startTodayCard from '../partials/start-today-card.vue';
import applicantOnboardingCard from '../partials/applicant-onboarding-card.vue';
export default {
    name: "CoinsBanner",
    props: ["banner", "isBusiness"],
    components: {
        startTodayCard,
        applicantOnboardingCard
    },
    data() {
        return {
            imgBase: "https://cdn.redgirasol.com/nuevo_portal/banners/banner-"
        }
    },
    computed: {
        getPlaceHolders() {
            if (this.isBusiness == null) {
                return {
                    nameHolder: "Sergio Pérez",
                    emailHolder: 'rg@personal.com'
                }
            }
            if (this.isBusiness) {
                return {
                    nameHolder: "Rodrigo Gonzalez",
                    emailHolder: 'rg@pyme.com'
                }
            } else {
                return {
                    nameHolder: "Roberta García",
                    emailHolder: 'rg@ecotecnologias.com'
                }
            }
        },
        getOriginLanding() {
            if (this.isBusiness == null) {
                return "Crédito Personal"
            }
            if (this.isBusiness) {
                return "Crédito PYME"
            } else {
                return "Crédito Ecotecnologías"
            }
        }   
    }
}

</script>

<style scoped>
.form-floating-parent {
    position: relative;
    /* top: 6rem; */
}
.form-floating-child {
    position: absolute;
    bottom: -35%;
    right: 1rem;
}

.project-add-banner .content {
    padding-right: 0;
}

@media only screen and (max-width: 575px) {
    .form-floating-child {
        position: absolute;
        bottom: -70%;
        right: auto;
    }

    .project-add-banner {
        background-repeat: repeat !important;
        background-position-y: 0rem !important;
        background-position-x: -60rem !important;
    }
}

@media only screen and (max-width: 991px) {
    .banner.banner-style-2 {
        top: 4rem !important;
    }

    .form-floating-child {
        position: absolute;
        bottom: -70%;
        right: auto;
    }
}

</style>